import styled from 'styled-components';

import Card from '@components/Card';

const Container = styled(Card)`
  cursor: pointer;
  justify-content: space-between;
  width: ${({ width }) => width || '100%'};
  position: relative;
`;

export default Container;
